/**
 * Open and close the mobile header
 */

const navToggle = ($) => {
	$("#nav-toggle").on("click", function () {
		const header = $("#header");
		const body = $("body");

		if (header.hasClass("js-open-mobile-menu")) {
			header.removeClass("js-open-mobile-menu");
			body.removeClass("js-lock-body");
		} else {
			header.addClass("js-open-mobile-menu");
			body.addClass("js-lock-body");
		}
	});
};

export default navToggle;
